<template>
  <div>
    <div id="jstream" />
  </div>
</template>
<script>
export default {
  name: "JStreamPlayer",
  props: {
    videoId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      jStreamPlayer: {}
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init: function() {
      this.loadJStreamApi()
        .then(() => {
          this.jStreamPlayer = window.jstream_t3.PlayerFactoryIF.create(
            {
              b: "eqc354paex.eq.webcdn.stream.ne.jp/www50/eqc354paex/jmc_pub/jmc_swf/player/",
              c: "MjczOA==",
              m: this.videoId,
              s: {
                dq: "0",
                el: "off",
                mdq: "0",
                pr: "2.0",
                rp: "fit",
                tg: "off"
              }
            },
            "jstream"
          )
        })
        .catch(error => {
          console.error("JStreamの読み込みに失敗しました。")
          console.error(error)
        })
    },
    loadJStreamApi: function() {
      let jstreamUrl = this.$config.app.jstreamUrl
      return new Promise(function(resolve, reject) {
        let el = document.createElement("script")
        el.type = "text/javascript"
        el.src = jstreamUrl
        document.head.appendChild(el)

        el.addEventListener("error", reject)
        el.addEventListener("abort", reject)
        el.addEventListener("load", function() {
          resolve(el)
        })
      })
    },
    play() {
      this.jStreamPlayer.accessor.play()
    }
  }
}
</script>
